import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Travellers, { TravellersItem } from '@ott/travellers';
import PlusMinus from '@ott/plus-minus';
import TravellersChildren from '@ott/travellers-children';

import { l10n } from '@ott/l10n';

import TravellersFooter from './blocks/TravellersFooter';

import s from './TravellersWrapper.scss';

class TravellersWrapper extends PureComponent {
  static propTypes = {
    adults: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    totalChildren: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    ages: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    formValues: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    maxPassengers: PropTypes.number.isRequired,
    onAdultsChange: PropTypes.func.isRequired,
    onTotalChildrenChange: PropTypes.func.isRequired,
    isAbsoluteOverlayPosition: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    const { adults, totalChildren } = props;

    this.travellersClassNames = {
      container: s.travellersContainer,
      ...props.childrenClassNames,
    };

    this.handleFocus = this.handleFocus.bind(this, { adults, totalChildren });
    this.handleBlur = this.handleBlur.bind(this, { adults, totalChildren });
  }

  handleFocus = (fields, event) => {
    ['adults', 'totalChildren'].forEach((entity) => {
      const field = fields[entity];
      if (field && field.input) {
        field.input.onFocus(event);
      }
    });
  };

  handleBlur = (fields, event) => {
    ['adults', 'totalChildren'].forEach((entity) => {
      const field = fields[entity];
      if (field && field.input) {
        field.input.onBlur(event);
      }
    });
  };

  getAgeTitle = (age) => {
    return l10n('travellersControl.childAde', { age: +age + 1 });
  };

  getAgesTitle = () => {
    return l10n('travellersControl.chooseChildAgeRailways');
  };

  getSelectedAgeTitle = (age) => {
    return `${l10n('travellersControl.child')}, ${this.getAgeTitle(age)}`;
  };

  getTriggerValue() {
    const {
      adults: { input: adultsInput = {} },
      totalChildren: { input: childrenInput = {} },
    } = this.props;

    const numberOfChildren = childrenInput.value.length;
    const numberOfAdults = +adultsInput.value;

    const adultsText = `${numberOfAdults} ${l10n('adults', { value: numberOfAdults })}`;
    const childrenText = numberOfChildren
      ? `, ${numberOfChildren} ${l10n('children', { value: numberOfChildren })}`
      : '';

    return adultsText + childrenText;
  }

  renderTravellersItem = (adults, childrenAges) => {
    const { ages, formValues, maxPassengers } = this.props;

    const childrenAgeRange = {
      start: 0,
      end: ages.child.age,
    };

    const childrenAgesValue = childrenAges.input.value || [];
    const currentChildrenAndInfantsQuantity = childrenAgesValue.length;
    const maxAdults = Math.max(maxPassengers - currentChildrenAndInfantsQuantity, 0);
    const maxChildren = Math.max(maxPassengers - formValues.adults, 0);

    const value = adults.input.value;

    const adultsNode = (
      <PlusMinus
        min={0}
        max={maxAdults}
        value={value}
        label={`${value} ${l10n('adults', { value })}`}
        onChange={adults.input.onChange}
      />
    );
    const childrenNode = (
      <TravellersChildren
        maxChildren={maxChildren}
        childrenAgeRange={childrenAgeRange}
        getAgeTitle={this.getAgeTitle}
        getAgesTitle={this.getAgesTitle}
        getSelectedAgeTitle={this.getSelectedAgeTitle}
        childrenAges={childrenAges.input.value}
        onChildrenAgesChange={childrenAges.input.onChange}
      />
    );

    return <TravellersItem adultsNode={adultsNode} childrenNode={childrenNode} />;
  };

  render() {
    const {
      adults: adultsField,
      totalChildren: childrenField,
      onAdultsChange,
      onTotalChildrenChange,
      ages,
      isAbsoluteOverlayPosition,
    } = this.props;

    adultsField.input.onChange = onAdultsChange;
    childrenField.input.onChange = onTotalChildrenChange;

    const triggerValue = this.getTriggerValue();
    const isInvalid =
      adultsField.meta.submitFailed && (childrenField.meta.invalid || adultsField.meta.invalid);

    const footerNode = <TravellersFooter ages={ages} />;

    return (
      <Travellers
        childrenClassNames={this.travellersClassNames}
        placeholder="Пассажиры"
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        isInvalid={isInvalid}
        triggerValue={triggerValue}
        travellersList={this.renderTravellersItem(adultsField, childrenField)}
        footer={footerNode}
        hasDoneButton={true}
        usePortalOverlay={false}
        isAbsoluteOverlayPosition={isAbsoluteOverlayPosition}
        withArrowIcon={true}
      />
    );
  }
}

export default TravellersWrapper;
